<div class="link-container">
  <a
    href="http://www.caci.co.uk/copyrightnotices.pdf"
    target="_blank"
    class="link"
    i18n="@@copyrightNotices"
    >Copyright Notices</a
  >
</div>
